import {} from '@tanstack/react-query';
import _noop from 'lodash/noop';
import { createContext, useContext } from 'react';
import { queryClient } from './QueryClient.client';
export const queryContext = createContext(queryClient);
export const QueryDevtoolsContext = createContext({
    toggleDevtools: _noop,
});
export const useQueryDevtools = () => useContext(QueryDevtoolsContext);
